.wrap {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.primary,
.secondary {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: var(--h-ctl);
  padding: 0 14px;
  border-radius: var(--radius-chip);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition:
    background-color var(--dur-1) var(--ease-std),
    border-color var(--dur-1) var(--ease-std);
}

/* Solid teal: the page-level action. */
.primary {
  border: 1px solid var(--accent);
  background: var(--accent);
  color: var(--on-fill);
}

.primary:hover:not(:disabled) {
  border-color: var(--accent-h);
  background: var(--accent-h);
}

/* White with teal text and a border: row actions and everything that is not the page's one action. */
.secondary {
  border: 1px solid var(--accent-line);
  background: var(--panel);
  color: var(--accent);
}

.secondary:hover:not(:disabled) {
  border-color: var(--accent);
  background: var(--accent-w);
}

.primary:focus-visible,
.secondary:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

/* Neutral grey on either weight. */
.primary:disabled,
.secondary:disabled {
  border-color: var(--btn-off-bg);
  background: var(--btn-off-bg);
  color: var(--btn-off-ink);
  cursor: not-allowed;
}

.reason {
  color: var(--muted);
  font-size: var(--t-min);
  line-height: 16px;
}
